import logScreenView from '@zr/utilities/logScreenView';
import logScreenInteraction from '@zr/utilities/telemetry/logScreenInteraction';

import getFlowSuperProperties from './getFlowSuperProperties';

/**
 * @typedef {Object} ScreenTypeTelemetry
 * @property {Function} logView Fires a view event with any extra properties.
 * @property {Function} logInteraction Fires an interaction event with any extra properties.
 * @property {Function} logFinish Fires an interaction event when the screen type is finished.
 */

/**
 * Helper telemetry function that handles apply flow super properties and convenient methods to log screen_view and screen_interaction
 *
 * @param {string} screenType screen type name
 * @param {object} applyData apply flow data (see applyFlowPropTypes)
 * @returns {ScreenTypeTelemetry} object with logView, logInteraction, and logfinish
 */
export default function screenTypeTelemetry(screenType, applyData) {
  const superProperties = getFlowSuperProperties(applyData);

  /**
   * This fires a view event with any extra properties
   * A common one is screen_view_name, which defaults to the screen type if it's not provided
   */
  const logView = (extraProperties = {}) => {
    logScreenView(applyData.areaName, screenType, {
      ...superProperties,
      // default screen_view_name to the screenType
      screen_view_name: screenType,
      ...extraProperties,
    });
  };

  /**
   * This fires an interaction event with any extra properties
   */
  const logInteraction = (interaction, extraProperties = {}) => {
    logScreenInteraction(applyData.areaName, screenType, {
      ...superProperties,
      ...extraProperties,
      interaction,
    });
  };

  /**
   * This fires an interaction event when the screen type is finished
   * This should only be fired once after the job seeker successfully finished
   */
  const logFinish = (extraProperties = {}) => {
    logScreenInteraction(applyData.areaName, screenType, {
      ...superProperties,
      // let interaction be overridden by extraProperties
      interaction: 'submit',
      ...extraProperties,
      finished_screen_type: true,
    });
  };

  return {
    logInteraction,
    logView,
    logFinish,
  };
}
